import type { VideoItemDto } from '@customTypes/types';
import { Accordion, Loader, Text } from '@mantine/core';
import { translate } from '@shared/i18n/translate';
import { useState, useRef } from 'react';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { resolveImagePath } from '@/shared/helper/resolveImagePath'; // for thumbnails

const VideoItem = ({ item }: { item: VideoItemDto }) => {
  const [showVideo, setShowVideo] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(true);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleShowVideo = () => {
    setShowVideo(true);
    setTimeout(() => videoRef.current?.play().catch(() => {}), 0);
  };

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '230px',
        // minHeight: '190px',
        borderRadius: 20,
        overflow: 'hidden',
        cursor: showVideo ? 'default' : 'pointer'
      }}
      onClick={!showVideo ? handleShowVideo : undefined}
    >
      {isPreviewLoading && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'rgba(255,255,255,0.5)',
            zIndex: 2
          }}
        >
          <Loader />
        </div>
      )}

      {!showVideo && (
        <>
          <img
            alt='video'
            src={resolveImagePath(item.thumbnailPath)}
            style={{
              width: '100%',
              display: isPreviewLoading ? 'none' : 'block',
              borderRadius: '20px'
            }}
            onLoad={() => setIsPreviewLoading(false)}
          />
          <div
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              pointerEvents: 'none',
              zIndex: 1
            }}
          >
            <div
              style={{
                width: 64,
                height: 64,
                borderRadius: '50%',
                backgroundColor: '#ff446380',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <div
                style={{
                  width: 0,
                  height: 0,
                  borderLeft: '16px solid white',
                  borderTop: '10px solid transparent',
                  borderBottom: '10px solid transparent',
                  marginLeft: '4px'
                }}
              />
            </div>
          </div>
        </>
      )}

      {showVideo && (
        <video
          ref={videoRef}
          controls
          disablePictureInPicture
          muted
          playsInline
          preload='none'
          src={resolveImagePath(item.filePath)}
          style={{
            width: '100%',
            borderRadius: '20px',
            maxHeight: '320px'
          }}
        />
      )}
    </div>
  );
};

export const ClubVideoAccordion = ({ videos }: { videos: VideoItemDto[] }) => (
  <Accordion.Panel>
    {videos?.length ? (
      <Swiper
        navigation
        modules={[Navigation, Pagination]}
        pagination={{ clickable: true }}
        slidesPerView={1}
        spaceBetween={10}
      >
        {videos.map((item) => (
          <SwiperSlide key={item.id}>
            <VideoItem item={item} />
          </SwiperSlide>
        ))}
      </Swiper>
    ) : (
      <Text c='dimmed' fz={12}>
        {translate('commons.notFound.generic')}
      </Text>
    )}
  </Accordion.Panel>
);
